// src/components/forms/RangePickerInput.tsx
import { DatePicker as AntdDatePicker } from "antd";
import type { RangePickerProps as DateRangePickerProps } from "antd/es/date-picker";
import React from "react";
const { RangePicker } = AntdDatePicker;
type DateRangePickerInputProps = DateRangePickerProps & {
  ariaLabel?: string; // Accessible label for screen readers
  ariaDescribedby?: string; // Link to additional help text
  picker?: "date" | "week" | "month" | "quarter"; // Picker type
};
const DateRangePicker: React.FC<DateRangePickerInputProps> = ({
  ariaLabel,
  ariaDescribedby,
  picker = "date",
  ...rest
}) => {
  return (
    <RangePicker
      aria-label={ariaLabel} // Accessible label
      aria-describedby={ariaDescribedby} // Link to help text
      picker={picker} // Specify the type of picker
      {...rest} // Pass other props to the RangePicker
    />
  );
};
export default DateRangePicker;
